var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { CircularProgressStyling, LoaderContainer, InnerContainer, LoadingText } from './styles';
import { CircularProgress } from '@material-ui/core';
var SpinnerLoader = /** @class */ (function (_super) {
    __extends(SpinnerLoader, _super);
    function SpinnerLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerLoader.prototype.render = function () {
        var _a = this.props, isLoading = _a.isLoading, loadingText = _a.loadingText, borderRadius = _a.borderRadius, size = _a.size, color = _a.color, backgroundColor = _a.backgroundColor;
        return (isLoading &&
            React.createElement(LoaderContainer, { borderRadius: borderRadius, backgroundColor: backgroundColor },
                React.createElement(InnerContainer, null,
                    React.createElement(CircularProgress, { style: CircularProgressStyling(size, color) }),
                    loadingText && React.createElement(LoadingText, null, loadingText))));
    };
    ;
    return SpinnerLoader;
}(React.Component));
export { SpinnerLoader };
